module.exports = __webpack_public_path__ + "img/Ruler.d8c34d6c.svg";